import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  // eslint-disable-next-line
  selector: 'tr[md-table-header]',
  templateUrl: './table-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderComponent {
  @Input() items: TableHeaderItem[] = [];
  @Input() activeSorter?: string;

  @Output() sortBy = new EventEmitter<string>();

  @HostBinding('class.items-table__header') itemsTableHeaderClass = true;
}

export interface TableHeaderItem {
  classes?:
    | string
    | string[]
    | Set<string>
    | {
        [klass: string]: any;
      };
  sorter?: string;
  label: string;
}
